import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useJoinGroupRequest } from '../../../../hooks/useJoinGroupRequest';
import { handlePostMessage } from '../../../../hooks/useOpenManageRequestJoinGroup';
import { FilledDot } from '../../svgIcon/filled';

function RequestRemainingText() {
  const router = useRouter();
  const { gid } = router.query;
  const {
    query: { data: joinRequestListData },
  } = useJoinGroupRequest(gid as string, {
    refetchOnMount: true,
    keepPreviousData: true,
    enabled: !!gid,
  });

  useEffect(() => {
    const { joinRequestTab } = router.query;
    if (joinRequestTab === 'true') {
      handlePostMessage();
    }
  }, [router]);

  return joinRequestListData?.pages[0]?.totalCount > 0 ? (
    <div
      onClick={handlePostMessage}
      className="flex justify-center items-center gap-[12px] h-fit w-full lg:w-fit bg-primary_blue_bg cursor-pointer rounded-lg p-[10px_12px] "
    >
      <p className="text-[#242424] font-semibold text-sm leading-[16px] tracking-[-0.1px]">
        Có {joinRequestListData?.pages[0]?.totalCount} yêu cầu tham gia
      </p>
      <span className="text-[#EE3939] flex flex-col h-full items-center justify-center">
        <FilledDot />
      </span>
    </div>
  ) : null;
}

export default RequestRemainingText;
